import clsx from "clsx";

export const XStack: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({className, ...rest}) => {
  return <div className={clsx("flex flex-row", className)} {...rest} />;
};
